export enum CAMPAIGNS_QUERIES_ENUM {
  GET_TEMPLATES = 'GET_TEMPLATES',
}
